import _ from 'lodash';
import $ from 'jquery';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

const requestApi = function (data, path, type) {
  if (!type) {
    type = 'GET';
  }
  const url = _.get(globals, 'apiWebroot', '/') + path;

  return $.ajax({
    type,
    url,
    data,
    dataType: 'json',
  });
};

module.exports = {
  // Pieprasīt vienu jautājumu
  loadNextUnanswered() {
    const request = requestApi(null, 'questions/get_next_unanswered');

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (!_.isEmpty(data.status) && data.status == 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.QUESTION_LOAD_SUCCESS,
          question: data.question,
          score: data.score,
        });
      }
    });

    // fail
    request.fail((data) => {
      // location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
  // Saglabāt jautājumu
  saveAnswer(data, id) {
    const self = this;

    const request = requestApi(data, `questions/save_answer/${id}/1`, 'POST');
    AppDispatcher.dispatch({
      type: ActionTypes.ANSWER_SAVE,
    });

    // success
    request.done((data) => {
      if (!_.isEmpty(data.status) && data.status == 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.ANSWER_SAVE_SUCCESS,
        });
      } else if (data.status == 'error') {
        // self.skipQuestion(id);
        AppDispatcher.dispatch({
          type: ActionTypes.ANSWER_SAVE_FAIL,
        });
      }
    });

    request.fail((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.ANSWER_SAVE_FAIL,
      });
    });
  },
  // Saglabāt jautājumu
  skipQuestion(id) {
    const request = requestApi({}, `questions/skip_unanswered/${id}.json`, 'POST');
    AppDispatcher.dispatch({
      type: ActionTypes.QUESTION_SKIP,
    });

    // success
    request.done((data) => {
      if (!_.isEmpty(data.status) && data.status == 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.QUESTION_SKIP_SUCCESS,
        });
      } else if (data.status == 'error') {
        AppDispatcher.dispatch({
          type: ActionTypes.QUESTION_SKIP_FAIL,
        });
      }
    });

    request.fail((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.QUESTION_SKIP_FAIL,
      });
    });
  },
};
